<template lang="pug">
  v-card-title.py-2
    div.header-icon.round-corner.pa-6(
      v-if="!miniButton && !disabled",
      :class="$attrs.color || 'primary'",
      @click="redirect",
    ).white--text.text-sm-center
      v-icon(
        color="white",
      ).d-block fas fa-{{ icon }}

    div.d-flex.flex-grow
      v-row.header-filter(no-gutters)
        slot(name="filters")
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    icon: {
      type: String,
      required: true,
    },

    miniButton: {
      type: Boolean,
      default: false,
    },

    to: {
      validator: prop => typeof prop === 'object' || prop === null,
      default: null,
    },
  },

  methods: {
    redirect() {
      this.$emit('click');
      if (this.to) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>

<style lang="scss">
.header-icon {
  margin-top: -45px;
  width: 75px;
  height: 75px;
  cursor: pointer;
}

.header-filter {
  .action-wrapper {
    display: flex;
    justify-content: center;
    align-items: baseline;
  }
}
</style>
